export enum TCI_MEDIA_DISPLAY_MODE {
    MODE_LIST_VIEW,
    MODE_DETAIL_VIEW,
    MODE_PROMOTE_VIEW,
    MODE_MODAL_VIEW,
}

export enum TCI_MEDIA_EDIT_MODES {
    EDIT_CREATE,
    EDIT_UPDATE
}

export class TCIMediaDisplaySize {
    public static TINY = new TCIMediaDisplaySize(100, 100);
    public static SMALL = new TCIMediaDisplaySize(100, 100);
    public static MEDIUM = new TCIMediaDisplaySize(100, 100);
    public static LARGE = new TCIMediaDisplaySize(100, 100);
    public static XLARGE = new TCIMediaDisplaySize(100, 100);

    private constructor(private width: number, private height: number) {
    }
}

export enum TCI_MEDIA_FIELD_NAME {
    LISTING_ICON = "listingIcon",
    MEDIA_ICON = "media-"
}

export interface ITCIMediaAssetMap {
    /**
     *  Media asset map
     */
    [fileName: string]: ITCIMediaAsset;
}

/**
 * Media asset
 */
export interface ITCIMediaAsset {
    /**
     * field Name
     */
    fieldName?: string;
    /**
     * mediaUrl if content not present
     */
    mediaUrl: string;
    /**
     * byte encoding
     */
    encoding?: string;
    /**
     * mime type
     */
    mimeType?: string;
    /**
     * content if url not present
     */
    content?: string | File | any;
}

/**
 * Constants for ng-media component
 */
export const MAX_ASSET_UPLOAD_ALLOWED = 5; // 5 images or 4 images + 1 Video
export const MAX_UPLOAD_MB_ALLOWED = 1; // 1 MB

export interface ITCISupportedMediaImageSpecs {
    extension: string;
    finalFileName?: string;
    optional?: boolean;
}

export const supportedMediaImageSpecs = (): ITCISupportedMediaImageSpecs[] =>
     [
         {
            extension: "jpg"
         },
         {
             extension: "jpeg"
         },
         {
             extension: "png"
         }
    ];

export enum mediaMimeType {
    VIDEO = "video/*",
    IMAGE = "image/*"
}
